import React, { useCallback, useState } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { SynevoSearch } from '../../components/Synevo/SynevoSearch';
import { TabsHistory } from '../../../app/components/TabsHistory';

export const SynevoView: React.FC = () => {
  const spd = useSpdCore();
  const [refresh, setRefresh] = useState<boolean>(false);

  const onRefresh = () => {
    setRefresh(prev => !prev);
  };

  const getAllData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.synevo.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        onRefresh,
      ),
    [spd.synevo],
  );

  const getWaitingData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.synevo.getWaitingByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        onRefresh,
      ),
    [spd.synevo],
  );

  const getReadyData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.synevo.getReadyByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        onRefresh,
      ),
    [spd.synevo],
  );

  return (
    <Card>
      <TabsHistory activeKey="search" id="synevo" className="mb-3">
        <Tab eventKey="search" title="Synevo - wszystkie" className="m-3">
          <SynevoSearch
            getData={getAllData}
            getCount={spd.synevo.getAllCount}
            refresh={refresh}
          />
        </Tab>
        <Tab eventKey="waiting" title="oczekujące na wykonanie" className="m-3">
          <SynevoSearch
            getData={getWaitingData}
            getCount={spd.synevo.getWaitingCount}
            refresh={refresh}
          />
        </Tab>
        <Tab eventKey="ready" title="wykonane" className="m-3">
          <SynevoSearch
            getData={getReadyData}
            getCount={spd.synevo.getReadyCount}
            refresh={refresh}
            orderBy="synevoOrder.resultDate"
            withoutCancelButton={true}
          />
        </Tab>
      </TabsHistory>
    </Card>
  );
};
